// @flow

import React from 'react';
import _ from 'lodash';

import Ariane from 'PMT/components/Ariane';
import HourChooser from 'PMT/components/form/HourChooser';
import I18n from 'PMT/i18n/I18n';
import Listener from 'PMT/flux/Listener';
import CartModifier from 'PMT/entities/menu/CartModifier';
import Notify from 'PMT/utils/Notify';

import ApiConsumersStore from '../../../../stores/ApiConsumersStore';
import AbstractFormComponent from '../../../../components/form/AbstractFormComponent';
import Events from '../../../../constants/Events';
import RestaurantStore from '../../../../stores/RestaurantStore';
import CartModifierAction from '../../../../actions/CartModifierAction';
import CartModifierStore from '../../../../stores/CartModifierStore';
import RestaurantMenuAction from '../../../../actions/RestaurantMenuAction';
import RestaurantMenuStore from '../../../../stores/RestaurantMenuStore';
import RestaurantsGroupAction from '../../../../actions/RestaurantsGroupAction';
import RouteAction from '../../../../actions/RouteAction';
import RoutingEnum from '../../../../constants/RoutingEnum';
import SessionStore from '../../../../stores/SessionStore';
import SecurityContext from '../../../../utils/permissions/SecurityContext';

import View from './View';
import './style.scss';
import { EditPromotion } from '../fixture';

export default class PromotionsEdit extends AbstractFormComponent {
  state = this.getDefaultState();

  getDefaultState() {
    const cartModifier = this.isEditMode() ? CartModifierStore.getState().data : new CartModifier();
    return {
      restaurantMenuState: RestaurantMenuStore.getState(),
      cartModifierState: CartModifierStore.getState(),
      cartModifier: !_.isNull(cartModifier) ? cartModifier.copy() : cartModifier,
      defaultModifier: !_.isNull(cartModifier) ? cartModifier.copy() : cartModifier,
      apiConsumersState: ApiConsumersStore.getState(),
      restaurant: RestaurantStore.getRestaurant(),
    };
  }

  componentDidMount() {
    if (!RestaurantStore.getRestaurant().haveFeatureOrder()) {
      RouteAction.redirectToFeatureNonActivated();
      return;
    }

    if (!SecurityContext.cartModifiers.canRead()) {
      RouteAction.redirectForce(RoutingEnum.ORDERS_LIST);
    }

    CartModifierStore.addListener(this.onCartModifierStoreChange);

    ApiConsumersStore.addListener(this.onFetchApiConsumers);

    RestaurantMenuStore.addListeners([
      new Listener(Events.ON_LOADING_RESTAURANT_MENU, this.onFetchRestaurantMenu),
      new Listener(Events.ON_LOADING_RESTAURANT_MENU_SUCCESS, this.onFetchRestaurantMenu),
      new Listener(Events.ON_LOADING_RESTAURANT_MENU_ERROR, this.onFetchRestaurantMenu),
    ]);

    RestaurantMenuAction.loadRestaurantMenu();

    if (!_.isUndefined(this.props.match.params.cartModifierId)) {
      CartModifierAction.loadCartModifier(
        SessionStore.getRestaurantId(),
        this.props.match.params.cartModifierId
      );
    }

    RestaurantsGroupAction.loadApiConsumers(SessionStore.getRestaurantsGroupId(), {
      withOther: false,
      withParents: false,
    });
  }

  componentWillReceiveProps(nextProps) {
    // TODO: fix, redirect to EditPage on CartModifierStore POST_CART_MODIFIER_SUCCESS
    // from new to edit
    const fromNewToEdit =
        _.isNil(this.props.match.params.cartModifierId) && !_.isNil(
            nextProps.match.params.cartModifierId);

    // the id on url changed
    const idChanged =
      !_.isNil(this.props.match.params.cartModifierId) &&
        this.props.match.params.cartModifierId
        !== nextProps.match.params.cartModifierId;

    if (this.isEditMode() && (fromNewToEdit || idChanged)) {
      CartModifierAction.loadCartModifier(
        SessionStore.getRestaurantId(),
        this.props.match.params.cartModifierId
      );
    }
  }

  componentWillUnmount() {
    ApiConsumersStore.removeListener(this.onFetchApiConsumers);

    RestaurantMenuStore.removeListeners([
      new Listener(Events.ON_LOADING_RESTAURANT_MENU, this.onFetchRestaurantMenu),
      new Listener(Events.ON_LOADING_RESTAURANT_MENU_SUCCESS, this.onFetchRestaurantMenu),
      new Listener(Events.ON_LOADING_RESTAURANT_MENU_ERROR, this.onFetchRestaurantMenu),
    ]);
  }

  isEditMode(): boolean {
    return this.props.location.pathname
        !== RoutingEnum.ORDERS_CART_MODIFIERS_NEW.path;
  }

  onFetchApiConsumers = () => {
    this.setState({
      apiConsumersState: ApiConsumersStore.getState(),
    });
  };

  onCartModifierStoreChange = () => {
    this.setState(this.getDefaultState());
  };

  onFetchRestaurantMenu = () => {
    const restaurantMenuState = RestaurantMenuStore.getState();

    this.setState({
      restaurantMenuState,
    });
  };

  shouldDisableSubmit() {
    return !this.state.cartModifier.isFormValid();
  }

  haveModifications(): boolean {
    return (
      !_.isNull(this.state.cartModifier) &&
      !this.state.cartModifier.equals(this.state.defaultModifier) &&
      !(
        !_.isNull(this.state.cartModifier.target.items) &&
        _.isEmpty(this.state.cartModifier.target.items.itemsList)
      )
    );
  }

  handleChange = cartModifier => {
    this.setState({
      cartModifier: new CartModifier().fromJson(cartModifier),
    });
  };

  onSubmit = event => {
    event.preventDefault();

    const cartModifier = this.state.cartModifier;

    _.keys(cartModifier.condition.dateCondition.weeklyAvailabilities).map(day => {
      cartModifier.condition.dateCondition.weeklyAvailabilities[
        day
      ].hours = cartModifier.condition.dateCondition.weeklyAvailabilities[day].hours.filter(
        hour => !_.isNull(hour.opening) || !_.isNull(hour.closing)
      );
    });

    const isValid = cartModifier.isFormValid();

    if (isValid) {
      if (this.isEditMode()) {
        CartModifierAction.putCartModifier(SessionStore.getRestaurantId(), cartModifier);
      } else {
        CartModifierAction.postCartModifier(SessionStore.getRestaurantId(), cartModifier);
      }
    } else {
      Notify.alert('Formulaire invalide');
    }
  };

  render() {
    const restaurantMenuState = this.state.restaurantMenuState;
    const cartModifierState = this.state.cartModifierState;
    const apiConsumersState = this.state.apiConsumersState;
    const currencyCode = this.state.restaurant.currency;

    if (_.isEqual(RestaurantMenuStore.getInitialState(), restaurantMenuState)) {
      return this.renderLoading();
    }

    const arianeIcon = 'fa-line-chart';
    const arianeDetails = [
      {
        name: I18n.tr('menu.order'),
        link: RoutingEnum.ORDERS_LIST,
      },
      {
        name: I18n.tr('menu.order.cart_modifiers'),
        link: RoutingEnum.ORDERS_CART_MODIFIERS_LIST,
      },
      {
        name: this.isEditMode()
          ? I18n.tr('menu.order.cart_modifiers.edit')
          : I18n.tr('menu.order.cart_modifiers.new'),
        link: null,
      },
    ];

    return (
      <div className="order_cart_modifiers">
        <Ariane icon={arianeIcon} details={arianeDetails} />

        {restaurantMenuState.isFetching ||
        (this.isEditMode() && cartModifierState.isFetching) ||
        apiConsumersState.isFetching ? (
          this.renderOnLoadingContent()
        ) : (
          <div>
            <View
              restaurantMenu={restaurantMenuState.restaurantMenu}
              cartModifier={this.state.cartModifier}
              apiConsumers={this.state.apiConsumersState.data.apiConsumers}
              onChange={this.handleChange}
              currencyCode={currencyCode}
            />
            {this.renderFixedButtons()}
          </div>
        )}
      </div>
    );
  }
}
